/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker, FocusedInputShape, isInclusivelyBeforeDay } from 'react-dates';
import { ApplicationState } from 'store';
import _ from 'underscore';
import moment from 'moment';
import {
  ActivitiesTypes,
  ModalitiesTypes,
  OnlineSearchState,
  OnlineSearchTypes,
  PublicBodyTypes,
  RegionTypes,
  StatesTypes,
  SituationTypes,
  CitiesTypes,
  DateRangeTypes,
  MonitoredPortalsTypes,
} from 'store/modules/online_search_store/types';
import { States } from 'services/states';
import { Regions, RegionsStates } from 'services/regions';
import { Modalities } from 'services/modalities';
import { PublicAgencyTypes } from 'services/public_agency_types';
import { Situations } from 'services/situations';
import { getCitiesByStates } from 'services/actions/cities_actions';
import { getBiddings } from 'store/modules/bidding_store/actions';
import Select from 'react-select';
import MonitoringPortals from 'services/monitoring_portals';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import { ActivitiesState } from 'store/modules/activities_store/types';
import {
  createCustomSearch,
  deleteCustomSearch,
  updateCustomSearch,
} from 'services/actions/custom_search';
import ModalRemoveSearch from 'components/atoms/modal_remove_search';
import { PanelState } from 'store/modules/panel_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import ModalLocation from 'components/atoms/modal_location';
import { Container } from './styles';

interface InnerBoundTypes {
  lat: Number | undefined;
  lng: Number | undefined;
}

interface BoundsTypes {
  ne: InnerBoundTypes;
  sw: InnerBoundTypes;
}
interface OnlineSearchBiddingFormProps {
  searchBarOpened: boolean;
  setSearchBarOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const OnlineSearchBiddingForm = (props: OnlineSearchBiddingFormProps) => {
  const { searchBarOpened, setSearchBarOpened } = props;
  interface EventDatesTypes {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  }

  const dispatch = useDispatch();
  const { onlineSearch } = useSelector<ApplicationState, OnlineSearchState>(
    (state) => state.session.onlineSearch,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { activities } = useSelector<ApplicationState, ActivitiesState>(
    (state) => state.storage.activities,
  );

  const [statesList] = useState<Array<StatesTypes>>(States);
  const [states, setStates] = useState<Array<any>>(onlineSearch?.state_from_panel);

  const [modalitiesList, setModalitiesList] = useState<Array<ModalitiesTypes>>([]);
  const [situationsList, setSituationsList] = useState<Array<SituationTypes>>([]);
  const [publicBodyList, setPublicBodyList] = useState<Array<PublicBodyTypes>>([]);
  const [citiesList, setCitiesList] = useState<Array<CitiesTypes>>([]);
  const [citiesGeolocation, setCitiesGeolocation] = useState<Array<CitiesTypes>>([]);
  const [saveFilter, setSaveFilter] = useState<boolean>(false);
  const [updateFilter, setUpdateFilter] = useState<boolean>(false);
  const [filterName, setFilterName] = useState<string>(onlineSearch.filterActive.name);
  const [modalRemoveSearchOpened, setModalRemoveSearchOpened] = useState<boolean>(false);
  const [modalLocationOpened, setModalLocationOpened] = useState<boolean>(false);
  const [currentFocusedIncludeDate, setCurrentFocusedIncludeDate] =
    useState<null | FocusedInputShape>(null);
  const [currentFocusedDeadlineDate, setCurrentFocusedDeadlineDate] =
    useState<null | FocusedInputShape>(null);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const [addressSelected, setAddressSelected] = useState<string>('');
  const [bounds, setBounds] = useState<BoundsTypes>({
    ne: { lat: 0, lng: 0 },
    sw: { lat: 0, lng: 0 },
  });
  const [position, setPosition] = useState<google.maps.LatLngLiteral | null>(null);
  const [radius, setRadius] = useState<number>(onlineSearch.filters.radius || 10000);

  useEffect(() => {
    if (onlineSearch.filters.radius) {
      setRadius(onlineSearch.filters.radius);
    }
  }, [onlineSearch.filters.radius]);

  const portals = MonitoringPortals(profile.beta_tester);

  const onFilterChange = (
    value:
      | string
      | boolean
      | number
      | RegionTypes
      | Array<any>
      | DateRangeTypes
      | SituationTypes
      | null,
    field: string,
  ) => {
    dispatch({ type: OnlineSearchTypes.CHANGE_VALUE, field, value });
  };

  const handleRadiusChange: React.Dispatch<React.SetStateAction<number>> = (value) => {
    const resolved = typeof value === 'function' ? value(radius) : value;
    setRadius(resolved);
    onFilterChange(resolved, 'radius');
  };

  const regionChange = (region: RegionTypes) => {
    onFilterChange(RegionsStates[region.value], 'states');

    onFilterChange(region, 'region');
  };

  const handleDateChange = (eventDates: EventDatesTypes, field: string) => {
    const newDates = {
      from: eventDates.startDate ? eventDates.startDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ') : null,
      to: eventDates.endDate ? eventDates.endDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ') : null,
    };
    onFilterChange(newDates, field);
  };

  const handleActivityChange = (activity: ActivitiesTypes) => {
    let newActivities: Array<ActivitiesTypes> = [];

    if (
      onlineSearch.filters.activities.find((currentActivity) => currentActivity.id === activity.id)
    ) {
      newActivities = onlineSearch.filters.activities.filter(
        (currentActivity) => currentActivity.id !== activity.id,
      );
    }

    if (
      !onlineSearch.filters.activities.find((currentActivity) => currentActivity.id === activity.id)
    ) {
      newActivities = [...onlineSearch.filters.activities, activity];
    }

    onFilterChange(newActivities, 'activities');
  };

  const handleAllActivities = () => {
    let newActivities = activities[profile.currentCompany[tabId()]];

    if (
      activities[profile.currentCompany[tabId()]]?.length ===
      onlineSearch.filters.activities?.length
    )
      newActivities = [];

    onFilterChange(newActivities, 'activities');
  };

  const fetchBiddings = () => {
    if (profile.representant && profile.currentCompany[tabId()] !== profile.company_data.data.id) {
      dispatch(
        getBiddings(
          {
            per_page: onlineSearch.postsPerPage,
            activities_list: activities[profile.currentCompany[tabId()]],
            order: onlineSearch.orderedBy || null,
            order_direction: onlineSearch.orderedBy ? onlineSearch.orderDirection : null,
          },
          profile.currentCompany[tabId()],
        ),
      );
      return;
    }

    dispatch(
      getBiddings({
        per_page: onlineSearch.postsPerPage,
        activities_list: activities[profile.currentCompany[tabId()]],
        order: onlineSearch.orderedBy || null,
        order_direction: onlineSearch.orderedBy ? onlineSearch.orderDirection : null,
      }),
    );
  };

  useEffect(() => {
    dispatch({ type: OnlineSearchTypes.CLEAR_FILTER });
  }, [profile.currentCompany[tabId()]]);

  useEffect(() => {
    if (citiesGeolocation?.length === 0 || citiesGeolocation === undefined) return;

    onFilterChange(citiesGeolocation, 'cities');
    onFilterChange(addressSelected, 'address');
  }, [citiesGeolocation]);

  useEffect(() => {
    setModalitiesList(
      Modalities?.map((modality) => {
        return { label: `${modality.sigla} - ${modality.nome}`, value: modality.id };
      }),
    );
    setPublicBodyList(
      PublicAgencyTypes.filter((publicAgencyType) => publicAgencyType.id !== 6)?.map(
        (publicAgencyType) => {
          return { label: publicAgencyType.nome, value: publicAgencyType.id };
        },
      ),
    );
    setSituationsList(
      Situations.filter((situation) => ![2, 15, 16].includes(situation.id))?.map((situation) => {
        return { label: situation.resumo, value: situation.id };
      }),
    );
  }, []);

  useEffect(() => {
    if (onlineSearch?.state_from_panel.length >= 1) {
      onFilterChange(onlineSearch?.state_from_panel, 'states');
      onFilterChange(true, 'validities');
      onFilterChange(!onlineSearch.filters.updated, 'updated');
      dispatch({
        type: OnlineSearchTypes.STATE_FROM_PANEL,
        states_from_panel: [],
      });
    }

    (async () => {
      const statesIds = states?.map((state) => state.value);
      if (statesIds?.length > 0) {
        const citiesResponse = await getCitiesByStates(statesIds);
        if (citiesResponse?.length > 0) {
          setCitiesList(
            citiesResponse?.map((city: any) => {
              return { label: `${city.name_sub} - ${city.acronym}`, value: city.id };
            }),
          );
        } else {
          setCitiesList([]);
        }
      }
      if (statesIds?.length === 0) setCitiesList([]);
    })();
  }, [onlineSearch.filters.states, onlineSearch?.state_from_panel, states]);

  useEffect(() => {
    if (onlineSearch.filters.updated) {
      onFilterChange(!onlineSearch.filters.updated, 'updated');
    }
  }, [onlineSearch.filters.updated]);

  useEffect(() => {
    setFilterName(onlineSearch.filterActive.name || '');
  }, [onlineSearch.filterActive]);

  // const handleFilterByRegion = () => {
  //   setFilterByRegion(!filterByRegion);
  //   onFilterChange(null, 'region');
  //   onFilterChange([], 'cities');
  //   onFilterChange([], 'states');
  //   setCitiesList([]);
  // };

  const handleFilterGeolocationType = (type: string) => {
    if (type === 'localização') createTrack('Radar - Clicou na busca por raio de atuação');

    onFilterChange(type, 'geoType');
    onFilterChange(null, 'region');
    onFilterChange([], 'cities');
    onFilterChange([], 'states');
    onFilterChange('', 'address');
    setCitiesList([]);
  };

  const clearFilter = () => {
    dispatch({ type: OnlineSearchTypes.CLEAR_FILTER });
    setRadius(5000);
    setPosition(null);
    setBounds({
      ne: { lat: 0, lng: 0 },
      sw: { lat: 0, lng: 0 },
    });
    setStates([]);
    fetchBiddings();
  };

  const handleSaveFilter = async () => {
    const data = {
      id: onlineSearch.filterActive.id,
      contact_id: profile.id,
      name: filterName,
      filters: onlineSearch.filters,
    };

    const result = await createCustomSearch(data);
    if (result.success && result.filter) {
      dispatch({
        type: OnlineSearchTypes.FILTER_ACTIVE,
        filterActive: { id: result?.filter?.id, name: result?.filter?.name },
      });
      setSaveFilter(false);
      setFilterName('');
      onFilterChange(!onlineSearch.filters.updated, 'updated');
    }
  };

  const handleSaveFilterChange = () => {
    setSaveFilter((prevStatus) => {
      if (!prevStatus) {
        setFilterName(onlineSearch.filterActive.name || '');
        createTrack('Salvar pesquisa - Clicou no botão de salvar pesquisa');
      }
      return !prevStatus;
    });
  };

  const handleUpdateFilter = async () => {
    const updatedData = {
      contact_id: profile.id,
      name: filterName,
      filters: onlineSearch.filters,
    };

    const result = await updateCustomSearch(onlineSearch.filterActive.id, updatedData);
    if (result.success && result.filter) {
      dispatch({
        type: OnlineSearchTypes.FILTER_ACTIVE,
        filterActive: { id: result?.filter?.id, name: result?.filter?.name },
      });
      setSaveFilter(false);
      setUpdateFilter(false);
      onFilterChange(!onlineSearch.filters.updated, 'updated');
    }
  };

  const handleDeleteFilter = async () => {
    const result = await deleteCustomSearch(onlineSearch.filterActive.id);
    if (result.success) {
      dispatch({ type: OnlineSearchTypes.CLEAR_FILTER });
      fetchBiddings();
    }
  };

  const handleClick = (field: string, value: any) => {
    if (field === 'states') {
      setStates(value);
    }
    onFilterChange(value, field);
  };

  return (
    <Container>
      <div className="row">
        <div
          className={`col-11 mx-auto col-lg-3 col-md-12 pr-2 filter-bar shadow ${
            searchBarOpened ? '' : 'hide-bar'
          } ${
            profile.in_sample || panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          }`}
        >
          <button
            type="button"
            onClick={() => setSearchBarOpened(!searchBarOpened)}
            className="btn btn-sm btn-link position-absolute btn-hide-search d-xxl-none"
          >
            <i className="material-icons">keyboard_arrow_right</i>
          </button>
          <div className="filter-form pr-2">
            <div className="row d-print-none">
              <div className="col-md-12 mb-3 pt-3 filter-form-acoes">
                {onlineSearch.filterActive.id > 0 ? (
                  <div className="d-flex justify-content-between align-items-center">
                    <span>
                      <strong>{onlineSearch.filterActive.name}</strong>
                    </span>
                    <button
                      className="btn btn-sm btn-link d-flex align-items-center"
                      type="button"
                      onClick={() => setModalRemoveSearchOpened(true)}
                    >
                      Excluir pesquisa
                      <i className="material-icons">delete</i>
                    </button>
                  </div>
                ) : (
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-sm btn-link float"
                      onClick={() => clearFilter()}
                    >
                      Limpar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-link float-right"
                      onClick={() => fetchBiddings()}
                    >
                      Recarregar
                    </button>
                  </div>
                )}
              </div>
              <div
                className={`col-md-12 ${
                  onlineSearch.filterActive.id > 0 && !updateFilter ? 'filter-active' : ''
                }`}
              >
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="objetoSearch" className="m-0">
                      Objeto
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="objetoSearch"
                      placeholder="Pesquise por Objeto"
                      onChange={(event) => onFilterChange(event.target.value, 'object')}
                      value={onlineSearch.filters.object}
                    />
                  </div>
                </div>
                <div className="form-check">
                  <input
                    onKeyDown={(keyEvent) => {
                      if (keyEvent.key === 'Enter')
                        onFilterChange(!onlineSearch.filters.updated, 'updated');
                    }}
                    checked={onlineSearch.filters.exact_search}
                    className="form-check-input"
                    type="checkbox"
                    id="exact_search"
                    onChange={() =>
                      onFilterChange(!onlineSearch.filters.exact_search, 'exact_search')
                    }
                  />
                  <label className="form-check-label" htmlFor="exact_search">
                    Busca Exata
                  </label>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-12">
                    <p className="mb-1">Filtrar por:</p>
                    <div className="d-flex justify-content-between">
                      <div className="form-check form-check-inline">
                        <input
                          disabled={false}
                          className="form-check-input"
                          type="radio"
                          name="pushRadioOptions"
                          id="pushRadioKeyword"
                          onChange={() => handleFilterGeolocationType('estado')}
                          checked={
                            onlineSearch.filters.geoType === 'estado' ||
                            onlineSearch.filters.geoType === ''
                          }
                        />
                        <label className="form-check-label" htmlFor="pushRadioKeyword">
                          Estado
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          disabled={false}
                          className="form-check-input"
                          type="radio"
                          name="pushRadioOptions"
                          id="pushRadioAll"
                          onChange={() => handleFilterGeolocationType('região')}
                          checked={onlineSearch.filters.geoType === 'região'}
                        />
                        <label className="form-check-label" htmlFor="pushRadioAll">
                          Região
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          disabled={false}
                          className="form-check-input"
                          type="radio"
                          name="pushRadioOptions"
                          id="pushRadioLocation"
                          onChange={() => handleFilterGeolocationType('localização')}
                          checked={onlineSearch.filters.geoType === 'localização'}
                        />
                        <label className="form-check-label" htmlFor="pushRadioLocation">
                          Raio de atuação
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {onlineSearch.filters.geoType === 'estado' && (
                  <>
                    <div className="row">
                      <div className="col-md-12">
                        <label htmlFor="stateSearch" className="m-0">
                          Estado
                        </label>
                        <Select
                          isMulti
                          name="StateSearch"
                          closeMenuOnSelect={false}
                          value={onlineSearch.filters.states || ''}
                          // value={states}
                          onChange={(selected) =>
                            handleClick('states', selected as Array<StatesTypes>)
                          }
                          options={statesList}
                          placeholder="Selecione os Estados"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between col-md-12 p-0">
                      <div className="float-right date-template">
                        <button
                          type="button"
                          className="btn btn-sm btn-link pr-0"
                          onClick={() => {
                            setStates(statesList);
                            onFilterChange(statesList, 'states');
                          }}
                        >
                          Todos os Estados
                        </button>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-12">
                        <label htmlFor="citySearch" className="m-0">
                          Cidade
                        </label>
                        <Select
                          name="CitySearch"
                          isMulti
                          closeMenuOnSelect={false}
                          value={onlineSearch.filters.cities || ''}
                          onChange={(selected) =>
                            onFilterChange(selected as Array<CitiesTypes>, 'cities')
                          }
                          options={citiesList}
                          noOptionsMessage={() => 'Selecione uma cidade'}
                          placeholder="Selecione as Cidades"
                        />
                      </div>
                    </div>
                  </>
                )}
                {onlineSearch.filters.geoType === 'região' && (
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="RegionSearch" className="m-0">
                        Região
                      </label>
                      <div>
                        <Select
                          name="RegionSearch"
                          value={onlineSearch.filters.region || ''}
                          onChange={(selected) => {
                            regionChange(selected as RegionTypes);
                          }}
                          options={Regions}
                          placeholder="Selecione uma Região"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {onlineSearch.filters.geoType === 'localização' && (
                  <div className="row">
                    <div className="col-md-12">
                      {onlineSearch.filters.address !== '' && (
                        <div className="alert alert-secondary">{`${radius / 1000} km de ${
                          onlineSearch.filters.address
                        }`}</div>
                      )}
                      <button
                        type="button"
                        className="btn btn-link m-0 p-0 btn-block mt-2"
                        onClick={() => {
                          setModalLocationOpened(true);
                        }}
                      >
                        {onlineSearch.filters.address === ''
                          ? 'Buscar Endereço'
                          : 'Editar Endereço'}
                      </button>
                    </div>
                  </div>
                )}
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="editalSearch" className="m-0">
                      Nº Edital
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      id="editalSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Edital"
                      value={onlineSearch.filters.noticeNumber}
                      onChange={(event) => onFilterChange(event.target.value, 'noticeNumber')}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="modalitiesSearch" className="m-0">
                      Modalidades
                    </label>

                    <Select
                      name="modalitiesSearch"
                      isMulti
                      closeMenuOnSelect={false}
                      value={onlineSearch.filters.modalities}
                      onChange={(selected) =>
                        onFilterChange(selected as Array<ModalitiesTypes>, 'modalities')
                      }
                      options={modalitiesList}
                      placeholder="Selecione as Modalidades"
                    />
                    <div className="float-right date-template">
                      <button
                        type="button"
                        className="btn btn-sm btn-link"
                        onClick={() => onFilterChange(modalitiesList, 'modalities')}
                      >
                        Todas as Modalidades
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <label>Data Inclusão</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <DateRangePicker
                          startDate={
                            _.isNull(onlineSearch.filters.includeDateRange.from)
                              ? null
                              : moment(onlineSearch.filters.includeDateRange.from)
                          }
                          startDateId="includeDateRange_start_date_id"
                          minimumNights={0}
                          endDate={
                            _.isNull(onlineSearch.filters.includeDateRange.to)
                              ? null
                              : moment(onlineSearch.filters.includeDateRange.to)
                          }
                          endDateId="includeDateRange_end_date_id"
                          onDatesChange={(eventDates) =>
                            handleDateChange(eventDates, 'includeDateRange')
                          }
                          focusedInput={currentFocusedIncludeDate}
                          onFocusChange={(focusedIncludeDateRange) => {
                            setCurrentFocusedIncludeDate(focusedIncludeDateRange);
                          }}
                          startDatePlaceholderText="De"
                          endDatePlaceholderText="Até"
                          hideKeyboardShortcutsPanel
                          displayFormat="DD/MM/YYYY"
                          isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
                          showClearDates
                          small
                          numberOfMonths={1}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 mt-1 date-template">
                        <a
                          href="#"
                          onClick={() => {
                            const newDate = {
                              from: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                              to: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                            };
                            onFilterChange(newDate, 'includeDateRange');
                          }}
                          className="mr-2"
                        >
                          hoje
                        </a>
                        <a
                          href="#"
                          onClick={() => {
                            const newDate = {
                              from: moment()
                                .subtract(1, 'days')
                                .format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                              to: moment().subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                            };
                            onFilterChange(newDate, 'includeDateRange');
                          }}
                        >
                          ontem
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <label>Data Prazo</label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <DateRangePicker
                          startDate={
                            _.isNull(onlineSearch.filters.deadlineDateRange.from)
                              ? null
                              : moment(onlineSearch.filters.deadlineDateRange.from)
                          }
                          startDateId="deadlineDateRange_start_date_id"
                          minimumNights={0}
                          endDate={
                            _.isNull(onlineSearch.filters.deadlineDateRange.to)
                              ? null
                              : moment(onlineSearch.filters.deadlineDateRange.to)
                          }
                          endDateId="deadlineDateRange_end_date_id"
                          onDatesChange={(eventDates) =>
                            handleDateChange(eventDates, 'deadlineDateRange')
                          }
                          focusedInput={currentFocusedDeadlineDate}
                          onFocusChange={(focusedDeadlineDateRange) => {
                            setCurrentFocusedDeadlineDate(focusedDeadlineDateRange);
                          }}
                          startDatePlaceholderText="De"
                          endDatePlaceholderText="Até"
                          hideKeyboardShortcutsPanel
                          displayFormat="DD/MM/YYYY"
                          isOutsideRange={() => false}
                          showClearDates
                          small
                          numberOfMonths={1}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label>Licitações</label>
                    <div className="form-check tour-option-currents-biddings">
                      <input
                        onKeyDown={(keyEvent) => {
                          if (keyEvent.key === 'Enter')
                            onFilterChange(!onlineSearch.filters.updated, 'updated');
                        }}
                        checked={onlineSearch.filters.validities}
                        className="form-check-input"
                        type="checkbox"
                        id="vigenteShearch"
                        onChange={() =>
                          onFilterChange(!onlineSearch.filters.validities, 'validities')
                        }
                      />
                      <label className="form-check-label" htmlFor="vigenteShearch">
                        Vigentes
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        onKeyDown={(keyEvent) => {
                          if (keyEvent.key === 'Enter')
                            onFilterChange(!onlineSearch.filters.updated, 'updated');
                        }}
                        checked={onlineSearch.filters.hasNotice}
                        className="form-check-input"
                        type="checkbox"
                        id="comEditalShearch"
                        onChange={() =>
                          onFilterChange(!onlineSearch.filters.hasNotice, 'hasNotice')
                        }
                      />
                      <label className="form-check-label" htmlFor="comEditalShearch">
                        Com Edital
                      </label>
                    </div>
                    {/* Match em fase alfa: o backend também ignora o filtro para os demais clientes. */}
                    {profile?.alfa_tester && (
                      <div className="form-check">
                        <input
                          onKeyDown={(keyEvent) => {
                            if (keyEvent.key === 'Enter')
                              onFilterChange(!onlineSearch.filters.updated, 'updated');
                          }}
                          checked={!!onlineSearch.filters.onlyMatch}
                          className="form-check-input"
                          type="checkbox"
                          id="licitacoesCompativeisSearch"
                          onChange={() =>
                            onFilterChange(!onlineSearch.filters.onlyMatch, 'onlyMatch')
                          }
                        />
                        <label className="form-check-label" htmlFor="licitacoesCompativeisSearch">
                          Licitações compatíveis
                        </label>
                      </div>
                    )}
                    <div className="form-check tour-monitoring-biddings-filter">
                      <input
                        onKeyDown={(keyEvent) => {
                          if (keyEvent.key === 'Enter')
                            onFilterChange(!onlineSearch.filters.updated, 'updated');
                        }}
                        checked={onlineSearch.filters.hasMonitored}
                        className="form-check-input"
                        type="checkbox"
                        id="comMonitoramentoShearch"
                        onChange={() =>
                          onFilterChange(!onlineSearch.filters.hasMonitored, 'hasMonitored')
                        }
                      />
                      <label className="form-check-label" htmlFor="comMonitoramentoShearch">
                        Com Monitoramento de Chat
                      </label>
                    </div>
                    {onlineSearch.filters.hasMonitored && (
                      <div className="row">
                        <div className="col-md-12">
                          <hr />
                          <label htmlFor="monitoredPortalsSearch" className="m-0">
                            Portais do Monitorar Chat
                          </label>
                          <Select
                            name="monitoredPortalsSearch"
                            isMulti
                            closeMenuOnSelect={false}
                            value={onlineSearch.filters.monitoredPortals}
                            onChange={(selected) =>
                              onFilterChange(
                                selected as Array<MonitoredPortalsTypes>,
                                'monitoredPortals',
                              )
                            }
                            options={portals}
                            placeholder="Selecione os Portais"
                          />

                          <div className="float-right date-template">
                            <button
                              type="button"
                              className="btn btn-sm btn-link pr-0"
                              onClick={() => onFilterChange(portals, 'monitoredPortals')}
                            >
                              Todos os Portais
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="idSearch" className="m-0">
                      Nº Conlicitação
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      id="idSearch"
                      className="form-control"
                      placeholder="Pesquise por Nº Conlicitação"
                      value={onlineSearch.filters.id}
                      onChange={(event) => onFilterChange(event.target.value, 'id')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="codigoOrgaoSearch" className="m-0">
                      Código do Órgão
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="codigoOrgaoSearch"
                      placeholder="Pesquise por Código do Órgão"
                      value={onlineSearch.filters.uasg}
                      onChange={(event) => onFilterChange(event.target.value, 'uasg')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label className="m-0">Esfera</label>
                    <Select
                      isMulti
                      name="PublicBodyTypesSearch"
                      closeMenuOnSelect={false}
                      value={onlineSearch.filters.publicBodyTypes}
                      onChange={(selected) =>
                        onFilterChange(selected as Array<PublicBodyTypes>, 'publicBodyTypes')
                      }
                      options={publicBodyList}
                      placeholder="Todas as esferas"
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="processNumberSearch" className="m-0">
                      Nº Processo
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="processNumberSearch"
                      placeholder="Pesquise por Nº Processo"
                      value={onlineSearch.filters.processNumber}
                      onChange={(event) => onFilterChange(event.target.value, 'processNumber')}
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-12">
                    <label>Situação</label>
                    <br />
                    <Select
                      name="SituationSearch"
                      closeMenuOnSelect
                      value={onlineSearch.filters.situation}
                      onChange={(selected) => {
                        onFilterChange(selected, 'situation');
                      }}
                      options={situationsList}
                      placeholder="Selecione a Situação"
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="OrgaoSearch" className="m-0">
                      Órgão
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="OrgaoSearch"
                      placeholder="Pesquise por Órgão"
                      value={onlineSearch.filters.publicBody}
                      onChange={(event) => onFilterChange(event.target.value, 'publicBody')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="itensSearch" className="m-0">
                      Itens
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="itensSearch"
                      placeholder="Pesquise por Itens"
                      value={onlineSearch.filters.itens}
                      onChange={(event) => onFilterChange(event.target.value, 'itens')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="observacaoSearch" className="m-0">
                      Observação
                    </label>
                    <input
                      onKeyDown={(keyEvent) => {
                        if (keyEvent.key === 'Enter')
                          onFilterChange(!onlineSearch.filters.updated, 'updated');
                      }}
                      type="text"
                      className="form-control"
                      id="observacaoSearch"
                      placeholder="Pesquise por Observação"
                      value={onlineSearch.filters.note}
                      onChange={(event) => onFilterChange(event.target.value, 'note')}
                    />
                  </div>
                </div>
                <hr />
                <div className="row mb-3">
                  <div className="col-md-3 mt-1">
                    <label>Concorrência</label>
                    <div className="form-check tour-option-nacional-biddings">
                      <input
                        onKeyDown={(keyEvent) => {
                          if (keyEvent.key === 'Enter')
                            onFilterChange(!onlineSearch.filters.updated, 'updated');
                        }}
                        checked={onlineSearch.filters.national}
                        className="form-check-input"
                        type="checkbox"
                        id="nacionalShearch"
                        onChange={() => onFilterChange(!onlineSearch.filters.national, 'national')}
                      />
                      <label className="form-check-label" htmlFor="nacionalShearch">
                        Nacionais
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        onKeyDown={(keyEvent) => {
                          if (keyEvent.key === 'Enter')
                            onFilterChange(!onlineSearch.filters.updated, 'updated');
                        }}
                        checked={onlineSearch.filters.international}
                        className="form-check-input"
                        type="checkbox"
                        id="internacionalShearch"
                        onChange={() =>
                          onFilterChange(!onlineSearch.filters.international, 'international')
                        }
                      />
                      <label className="form-check-label" htmlFor="internacionalShearch">
                        Internacionais
                      </label>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row mb-5">
                  <div className="col-md-12">
                    <label className="d-flex justify-content-between">
                      Atividades
                      <button
                        type="button"
                        key="activities_0"
                        className="btn btn-link p-0 btn-sm"
                        onClick={() => handleAllActivities()}
                      >
                        {onlineSearch.filters.activities?.length ===
                        activities[profile.currentCompany[tabId()]]?.length
                          ? 'Nenhuma Atividade'
                          : 'Todas as Atividades'}
                      </button>
                    </label>

                    {activities[profile.currentCompany[tabId()]]?.map((activity) => (
                      <div key={`activities_${activity.codigo}`} className="form-check">
                        <input
                          onKeyDown={(keyEvent) => {
                            if (keyEvent.key === 'Enter')
                              onFilterChange(!onlineSearch.filters.updated, 'updated');
                          }}
                          checked={
                            !!onlineSearch.filters.activities.find(
                              (currentActivity) => currentActivity.id === activity.id,
                            )
                          }
                          className="form-check-input"
                          type="checkbox"
                          id={`activities_${activity.codigo}`}
                          onChange={() => handleActivityChange(activity)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`activities_${activity.codigo}`}
                        >
                          {activity.nome}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 px-2 py-3 filter-button d-print-none">
            {onlineSearch.filterActive.id <= 0 && !updateFilter && (
              <div className="d-flex align-items-center justify-content-between bg-white pl-1 pb-2">
                <div>
                  <span>Salvar pesquisa?</span>
                </div>
                <div className="custom-control custom-switch py-2">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="save-filter"
                    checked={saveFilter}
                    onChange={handleSaveFilterChange}
                  />
                  <label className="custom-control-label" htmlFor="save-filter" />
                </div>
              </div>
            )}
            {onlineSearch.filterActive.id <= 0 && !updateFilter && !saveFilter && (
              <button
                type="button"
                className="btn btn-primary w-100 mt-2"
                onClick={() => {
                  track('licitacao.usou_consulta_online', { origem: 'consulta_online' });
                  onFilterChange(!onlineSearch.filters.updated, 'updated');
                }}
              >
                Pesquisar
              </button>
            )}
            {saveFilter && !onlineSearch.filterActive.id && (
              <>
                <input
                  type="text"
                  className="form-control mb-2"
                  id="filter-name"
                  placeholder="Digite o nome da pesquisa..."
                  value={filterName}
                  onChange={(e) => setFilterName(e.target.value)}
                />
                <button
                  type="button"
                  className={`btn w-100 ${
                    filterName.trim().length > 0 ? 'btn-primary' : 'btn-secondary'
                  }`}
                  disabled={filterName.trim().length === 0}
                  onClick={() => handleSaveFilter()}
                >
                  Salvar e Pesquisar
                </button>
              </>
            )}
            {updateFilter && (
              <>
                <input
                  type="text"
                  className="form-control mb-2"
                  id="edit-filter-name"
                  placeholder="Digite o nome da pesquisa..."
                  value={filterName}
                  onChange={(e) => setFilterName(e.target.value)}
                />
                <button
                  type="button"
                  className={`btn w-100 ${
                    filterName.trim().length > 0 ? 'btn-primary' : 'btn-secondary'
                  }`}
                  disabled={filterName.trim().length === 0}
                  onClick={() => handleUpdateFilter()}
                >
                  Atualizar e Pesquisar
                </button>
              </>
            )}
            {onlineSearch.filterActive.id > 0 && !updateFilter && (
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary w-100 mb-2"
                  onClick={() => {
                    clearFilter();
                    setSaveFilter(false);
                    setFilterName('');
                  }}
                >
                  Nova pesquisa
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => setUpdateFilter(true)}
                >
                  Editar pesquisa - {onlineSearch.filterActive.name}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <ModalRemoveSearch
        modalRemoveSearchOpened={modalRemoveSearchOpened}
        setModalRemoveSearchOpened={setModalRemoveSearchOpened}
        handleDeleteFilter={handleDeleteFilter}
      />
      <ModalLocation
        modalLocationOpened={modalLocationOpened}
        setModalLocationOpened={setModalLocationOpened}
        setAddressSelected={setAddressSelected}
        addressSelected={addressSelected}
        bounds={bounds}
        setBounds={setBounds}
        position={position}
        setPosition={setPosition}
        radius={radius}
        setRadius={handleRadiusChange}
        setCitiesGeolocation={setCitiesGeolocation}
      />
    </Container>
  );
};

export default OnlineSearchBiddingForm;
